






















import { GuildsApi } from '@/services/api/api.guilds';
import { GuildViewObject } from '@/types/apiServerContract';
import debounce from 'lodash-es/debounce';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Guild from '@/components/frontpage/armory/guilds/Guild.vue';
import urlHelperService from '@/services/url/urlHelper.service';
import Paginator from '@/components/paging/Paginator.vue';

@Component({
    components: { Guild, Paginator }
})
export default class ArmoryGuildSearch extends Vue {
    @Prop({ required: true, type: Number })
    realmId!: number;

    term: string = '';
    debouncedSearch = debounce(this.search, 250);
    loading: boolean = false;
    guilds: GuildViewObject[] = [];
    foundNothing: boolean = false;

    @Watch('term')
    onTermChange(term: string) {
        urlHelperService.setQueryParam('term', this.term);

        this.foundNothing = false;

        if (term.length >= 2) {
            this.debouncedSearch();
        } else {
            this.guilds = [];
            this.debouncedSearch.cancel();
        }
    }

    async search() {
        if (this.loading) return;

        this.loading = true;

        try {
            const result = await GuildsApi.Search(this.realmId, this.term);
            this.guilds = result.guilds;

            if (result.guilds.length === 0) {
                this.foundNothing = true;
            }
        } finally {
            this.loading = false;
        }
    }

    setup() {
        const term = urlHelperService.getQueryParam('term') as string;
        if (term) {
            this.term = term;
        }
    }

    created() {
        this.setup();
    }
}
